<script>
  import Link from "../../shared/Link.svelte";
  import { _ } from "svelte-i18n";
</script>

<div class="title">
  <h2>{$_("lesson-BxESn.h2-0")}</h2>
</div>
<hr />
<div class="text">
  <p>
    {@html $_("lesson-BxESn.p-0")}
  </p>
  <div align="center"><img width="300" src="/img/Map.png" alt="A map of Germany with its eight biggest cities marked: Hamburg, Berlin, Düsseldorf, Leipzig, Köln, Frankfurt, Stuttgart, Munich"></div>
  <p>
    {$_("lesson-BxESn.p-1")}
  </p>
  <p style="text-align: center">
    <strong>{$_("lesson-BxESn.strong-0")}<sup>2</sup></strong>
  </p>
  <div style="float: right"><img width="270" src="/img/MapLines.png" alt="The same map as above where the cities are connected in a circular path"></div>
  <p>
    {$_("lesson-BxESn.p-2")}
  </p>
  <p>
    {@html $_("lesson-BxESn.p-3-0")} {`$$S(n)=\\frac{(n-1)!}{2}$$`} {@html $_("lesson-BxESn.p-3-1")}
  </p>
  <h3>{$_("lesson-BxESn.h3-0")}</h3>
  <p>
    {@html $_("lesson-BxESn.p-4")}
  </p>
  <div align="center"><img width="400" src="/img/Optimization.png" alt="A hilly landscape with a marked path from the starting point on a hill to the end point in a valley."></div>
  <p style="text-align: center">
    <i>{$_("lesson-BxESn.i-0")}<sup>3</sup></i>
  </p>
</div>
<hr>
<div class="refs">
  <h3>{$_("references")}</h3>
  <ol>
    <li><Link target="https://de.wikipedia.org/wiki/Liste_der_Gro%C3%9Fst%C3%A4dte_in_Deutschland" newPage={true}>https://de.wikipedia.org/wiki/Liste_der_Gro%C3%9Fst%C3%A4dte_in_Deutschland</Link>, {$_("ref_access")}: 10.03.2022</li>
    <li><Link target="https://en.wikipedia.org/wiki/Travelling_salesman_problem" newPage={true}>https://en.wikipedia.org/wiki/Travelling_salesman_problem</Link>, {$_("ref_access")}: 10.03.2022</li>
    <li>Heena Rijhwani, <i>Optimization</i>, (2020), <Link target="https://medium.com/analytics-vidhya/optimization-acb996a4623c" newPage={true}>https://medium.com/analytics-vidhya/optimization-acb996a4623c</Link>, {$_("ref_access")}: 10.03.2022</li>
  </ol>
</div>

<style>
  .title h2, .refs h3 {
    background: -webkit-linear-gradient(90deg, #1a91bc, #2eb6e8);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  hr {
    border: 1px solid white;
    border-top: 1px solid #ddd;
    margin: 20px auto;
  }
</style>
